import { Box } from '@chakra-ui/react'

/**
 * Martelo de leilão. O `lni-hammer` do LineIcons é um martelo de obra, batendo em prego —
 * não existe malhete no conjunto, então ele é desenhado aqui.
 */
export function GavelIcon({ size }: { size: string }) {
  return (
    <Box
      as="svg"
      viewBox="0 0 24 24"
      w={size}
      h={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {/* cabeça do malhete, inclinada */}
      <rect x="2.8" y="4.2" width="10" height="5.4" rx="1.6" transform="rotate(-45 7.8 6.9)" />
      {/* cabo saindo do centro da cabeça */}
      <line x1="10.2" y1="9.3" x2="16.6" y2="15.7" />
      {/* base onde o malhete bate */}
      <rect x="11.5" y="17" width="10.5" height="3.6" rx="1.6" />
      <line x1="4.2" y1="20.8" x2="9.6" y2="20.8" />
    </Box>
  )
}
